import isEqual from 'lodash/isEqual';

export const compareFileUploads = (
  initialFiles?: number[],
  uploadedFiles?: number[]
): boolean => {
  if (!initialFiles && !uploadedFiles?.length) {
    return false;
  }
  return !isEqual(initialFiles, uploadedFiles);
};
